import coachingRoutes from "./training/coaching.routes"
import quizRoutes from "./training/quiz.routes"

export default [
    ...coachingRoutes,
    ...quizRoutes
]